module.exports = {
      id: "envelope-usage",
      viewBox: "0 0 160 120",
      url: __webpack_public_path__ + "svg-sprite-afa9d3605aa6d2fee8793cc86cfa3445.svg#envelope",
      toString: function () {
        return this.url;
      }
    }